export enum errorMessages {
  SOMETHING_WENT_WRONG = 'Something went wrong'
}
